import { LocationCSVUploadModalProvider } from '@/components/common/MultiFlightMap/components/LocationCSVUploadModal/context/LocationCSVUploadModalProvider';
import { LocationCSVUploadModal } from '@/components/common/MultiFlightMap/components/LocationCSVUploadModal/LocationCSVUploadModal';
import { useMultiFlightMap } from '@/components/common/MultiFlightMap/MultiFlightMap.context';
import { useModals } from '@/router';

export default function UploadLocationsModal() {
  const { countries } = useMultiFlightMap();
  const country = countries[0]?.toLocaleUpperCase();
  const modals = useModals();

  return (
    <LocationCSVUploadModalProvider initialCountry={country}>
      <LocationCSVUploadModal
        id="global-location-csv-upload-modal"
        isModalOpened
        onClose={() => modals.close()}
        theme="light"
      />
    </LocationCSVUploadModalProvider>
  );
}
